import { FormattedRelativeTime as IntlFormattedRelativeTime } from 'react-intl';
import { selectUnit } from 'libs/utils/date';
import { jsx as _jsx } from "react/jsx-runtime";

const FormattedRelativeTime = _ref => {
  let {
    value
  } = _ref;
  if (Number.isNaN(value)) return null;
  const {
    value: selectedUnitValue,
    unit
  } = selectUnit(value);
  const formattedDate = new Date(value).toLocaleDateString(undefined, {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  });
  return /*#__PURE__*/_jsx("span", {
    title: formattedDate,
    children: /*#__PURE__*/_jsx(IntlFormattedRelativeTime, {
      unit: unit,
      value: selectedUnitValue
    })
  });
};

export default FormattedRelativeTime;